import React from 'react';

import {
  TableBody,
  TableDataBody1Title,
  TableDataTitle,
  TableRow,
} from '../styling';
import { FormattedMessage } from 'react-intl';
import TableRendererValue from './TableRendererValue';

function TableRenderer({ tableContent }) {
  return (
    <table>
      <TableBody>
        {tableContent.map((entity) => {
          const {
            title,
            data,
            isArray = false,
            isDataI18n = false,
          } = entity;

          return (
            <TableRow key={`${title.id}-${title.defaultMessage}`}>
              <TableDataTitle>
                <TableDataBody1Title>
                  <FormattedMessage
                    id={title.id}
                    defaultMessage={title.defaultMessage}
                    description={title.description}
                  />
                </TableDataBody1Title>
              </TableDataTitle>
              <td>
                <TableRendererValue
                  isArray={isArray}
                  isDataI18n={isDataI18n}
                  titleId={title.id}
                  value={data}
                />
              </td>
            </TableRow>
          );
        })
        }
      </TableBody>
    </table>
  );
}

export default TableRenderer;
